import { apiClientWithRefreshToken } from "@/api/apiClient";
import { UpdateUserSchema } from "@/v2/schema/members";
import { User } from "@/v2/types";

export default async function UpdateUser({
    id,
    data,
}: {
    id: string;
    data: UpdateUserSchema;
}): Promise<User> {
    const formData = new FormData();

    formData.append("email", data?.email ?? "");
    formData.append("full_name", data?.full_name ?? "");
    formData.append("phone_number", data?.phone_number ?? "");
    formData.append("is_admin", String(data?.is_admin ?? false));
    formData.append("assigned_employee_id", data?.assigned_employee_id ?? "");

    for (const role of data.roles) {
        formData.append("roles", role);
    }

    const res = await apiClientWithRefreshToken({
        url: `/users/${id}`,
        method: "PUT",
        data: formData,
    });

    return res.data;
}
